export const ApiRoutes = {
  JOIN: '/pro/api/v1/users/join',
  ME: '/pro/api/v1/users/me',

  THREADS: '/pro/api/v1/threads/',

  SPEECH_TO_TEXT: `api/v1/audio/stt`,
  TEXT_TO_SPEECH: `api/v1/audio/tts`,

  VERIFY: '/pro/api/v1/fineco/verify',
  LOGOUT: '/pro/api/v1/fineco/logout',
  TTL: '/pro/api/v1/fineco/ttl',

  FINECO_PORTFOLIO_REPORT_DATA: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/report/data`,
  FINECO_PORTFOLIO_REPORT_EXCEL: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/report/excel`,
  FINECO_PORTFOLIO_PTF: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/ptf`,
  FINECO_PORTFOLIO_REPORT_PARAMETERS: (portfolioId: string) =>
    `/pro/api/v2/fineco/portfolios/${portfolioId}/report/parameters`,
  FINECO_PORTFOLIO_STORY: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/story`,
  FINECO_PORTFOLIO_REPORT_PDF: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/report/pdf`,
  FINECO_PORTFOLIOS_COMPARE: `/pro/api/v2/fineco/portfolios/compare`,
  FINECO_PORTFOLIO_SAVE: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/save`,
  FINECO_PORTFOLIO_IMPORT_XNET: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/import-xnet`,
  FINECO_PORTFOLIO_ACTIONS: `/pro/api/v2/fineco/portfolio-actions`,

  CREATE_PRODUCT_CARD_PDF: (isin: string) => `/pro/api/v1/fineco/product-card/${isin}`,
  CREATE_PRODUCT_CARD_COMPARE_PDF: `/pro/api/v1/fineco/product-card/compare`,

  //** Wrappers (FAM funds of funds) — homepage card red dot */

  WRAPPERS_STATUS: '/pro/api/v1/fineco/wrappers/status',

  WRAPPERS_SEEN: '/pro/api/v1/fineco/wrappers/seen',

  //** FAM FoF constituents widget (issue #90) */
  WRAPPERS_FAM_PARENTS: '/pro/api/v1/fineco/wrappers/fam-parents',
  WRAPPERS_FAM_CONSTITUENTS: (isin: string) => `/pro/api/v1/fineco/wrappers/fam-parents/${isin}/constituents`,

  //** Portafogli guidati (model-portfolio catalogue behind the dialog, issue #83) */
  MODEL_PORTFOLIOS: '/pro/api/v1/fineco/model-portfolios',


  //** Constraints */
  SEARCH_MICROCATEGORIES: (microCategorySearchString: string) =>
    `pro/api/v1/fineco/microcategories/search?query=${microCategorySearchString}`,
  SEARCH_PRODUCTS: (productSearchString: string) => `pro/api/v1/fineco/products/search?query=${productSearchString}`,
  MICROCATEGORY_NAMES: 'pro/api/v1/fineco/microcategory-names',
  PRODUCT_NAMES: (isins: string[]) => `pro/api/v1/fineco/product-names?isins=${isins.join(',')}`,
  PRODUCT_LISTS: '/pro/api/v1/fineco/product-lists',
  CREATE_PRODUCT_LIST: '/pro/api/v1/fineco/product-lists',
  UPDATE_PRODUCT_LIST: (listId: string) => `/pro/api/v1/fineco/product-lists/${listId}`,
  DELETE_PRODUCT_LIST: (listId: string) => `/pro/api/v1/fineco/product-lists/${listId}`,

  CONSTRAINTS_DEFAULT: '/pro/api/v1/fineco/constraints/defaults',
  PRODUCT_DISPLAY: '/pro/api/v1/fineco/constraints/products/display',

  //** Constraint profiles */
  CONSTRAINT_PROFILES: '/pro/api/v1/fineco/constraint-profiles',
  CONSTRAINT_PROFILE: (profileId: string) => `/pro/api/v1/fineco/constraint-profiles/${profileId}`,
  CONSTRAINT_PROFILES_PREDEFINITI: '/pro/api/v1/fineco/constraint-profiles/predefiniti',
  CONSTRAINT_PROFILES_PREDEFINITI_ALL: '/pro/api/v1/fineco/constraint-profiles/predefiniti-all',

  // Costs simulation
  COSTS_PRODUCTS_DISPLAY: '/pro/api/v1/fineco/costs/products/display',
};
